"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

/**
 * Vrati query part pre vyhladavanie textu bez diakritiky v plnej zhode (tak ako je zadany).
 *
 * Napriklad:
 * 'aáaa' =$match=> 'aaaa'
 * 'aáaa' =! $match=> 'aaaaaa'
 * 'aáaa aaa' =$match=> 'aaaa aaa'
 * 'aáaa aaa' =! $match=> 'aaaa aaaa'
 *
 * @param {string} fieldName
 * @param {string} value
 *
 * @returns {Object}
 */
var textMatchToQuery = function textMatchToQuery(fieldName, value) {
  return value === undefined ? undefined : (0, _defineProperty2.default)({}, fieldName, {
    $match: value
  });
};

var _default = textMatchToQuery;
exports.default = _default;